import React from "react";
import { Product } from "../../../../Redux/ecommersProduct/types";

interface DetailPageSizesProps {
  product: Product | null;
}

const DetailPageSizes: React.FC<DetailPageSizesProps> = ({ product }) => {
  if (!product) return null;

  // Extract unique sizes from variations
  const sizes = Array.from(new Set(
    product.variations?.map(v => 
      v.attributes?.["Size"] || 
      v.attributes?.["size"] || 
      v.attributes?.["Clothing Size"] ||
      v.attributes?.["UK Size"]
    ).filter(Boolean)
  )).sort();

  if (sizes.length === 0) return <span className="text-muted">Standard Size</span>;

  return (
    <>
      {sizes.map((size, index) => (
        <div className="content-highlight" key={index}>
          <label className="custom-control-label">
            <a href="#" onClick={(e) => e.preventDefault()}>
              <span className="badge badge-lg badge-circle text-dark border size">
                {size}
              </span>
            </a>
          </label>
        </div>
      ))}
    </>
  );
};

export default DetailPageSizes;
